import React from 'react';
import { useI18n } from '@/lib/i18n';

const BG_IMG = 'https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1800&q=80';

export default function About() {
  const { t } = useI18n();
  return (
    <section id="about" data-testid="about-section" className="relative bg-white py-24 md:py-32 overflow-hidden">
      {/* Decorative image on right side */}
      <div className="hidden lg:block absolute -right-40 top-1/2 -translate-y-1/2 w-[640px] h-[640px] opacity-[0.06] pointer-events-none">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${BG_IMG})` }}
        />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <div className="eyebrow text-[#C5A059] flex items-center gap-3">
            <span className="w-10 h-px bg-[#C5A059]" />
            {t.about.eyebrow}
          </div>
          <h2 className="heading-display mt-6 text-[#0A1128] text-3xl sm:text-4xl lg:text-5xl">{t.about.title}</h2>

          {/* Decorative image card */}
          <div className="hidden lg:block mt-12 relative aspect-[4/5] max-w-xs">
            <div className="absolute -top-3 -left-3 w-full h-full border border-[#C5A059]/40" />
            <div
              className="relative w-full h-full bg-cover bg-center"
              style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=900&q=80)' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128]/40 to-transparent" />
          </div>
        </div>
        <div className="lg:col-span-7 space-y-6 text-[#1E2229]/80 text-lg leading-relaxed">
          <p data-testid="about-p1">{t.about.p1}</p>
          <p data-testid="about-p2">{t.about.p2}</p>
          <p data-testid="about-p3">{t.about.p3}</p>
          <p data-testid="about-p4" className="text-[#0A1128] font-medium">
            {t.about.p4.split(/(\*\*[^*]+\*\*)/g).map((part, idx) =>
              part.startsWith('**') && part.endsWith('**') ? (
                <strong key={idx} className="text-[#C5A059] font-display font-medium not-italic">{part.slice(2, -2)}</strong>
              ) : (
                <React.Fragment key={idx}>{part}</React.Fragment>
              )
            )}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5 mt-14">
            {t.about.stats.map((s, i) => (
              <div
                key={i}
                data-testid={`about-stat-${i}`}
                className="group relative bg-[#0A1128] text-white p-7 lg:p-8 border-l-2 border-[#C5A059] hover:bg-[#12161F] transition-colors overflow-hidden"
              >
                <div className="absolute top-3 right-4 text-[10px] tracking-[0.3em] text-white/30">0{i + 1}</div>
                <div className="font-display text-5xl lg:text-6xl text-[#C5A059] leading-none">{s.value}</div>
                <div className="mt-4 text-sm uppercase tracking-[0.18em] text-white/80 font-medium">{s.label}</div>
                <div className="absolute bottom-0 left-0 h-px w-0 bg-[#C5A059] group-hover:w-full transition-all duration-700" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
